import get from 'lodash/get';

import { OPTIONS as CFD_OPTIONS } from 'pages/views/devices/DevicesPage/Options/types';

export const OPTIONS = {
  ACCOUNT_ID: 'accountId',
  LOCALE: 'locale',
  CURRENCY_CODE: 'currencyCode',
  DATE_TIME_FORMAT: 'dateTimeFormat',
  REGISTER_ID: 'registerId',
  REGISTER_NAME: 'registerName',
  SHOP_ID: 'shopId',
  SHOP_NAME: 'shopName',
  USER_ID: 'userId',
  ...CFD_OPTIONS,
} as const;

export const LEGACY_HUB_OPTIONS = 'CFD_OPTIONS';
export const HUB_OPTIONS = 'HUB_OPTIONS';

export const getOptions = () =>
  Object.assign(
    {
      [OPTIONS.IS_CUSTOMER_NAME_VISIBLE]: false,
      [OPTIONS.IS_UNTAXED_ITEM_NOTE_VISIBLE]: false,
      [OPTIONS.IS_QRCODE_VISIBLE]: false,
      [OPTIONS.IS_CONNECTION_STATUS_VISIBLE]: true,
      [OPTIONS.IS_LOGO_VISIBLE]: true,
      [OPTIONS.IS_DEBUG_MODE]: false,
    },
    JSON.parse(window.localStorage.getItem(HUB_OPTIONS) || '{}'),
    {
      [OPTIONS.ACCOUNT_ID]: window.merchantos.session.getSystemCustomerID(),
      [OPTIONS.LOCALE]:
        window.Localize?.getLanguage?.() || get(window, 'merchantos.locale.lang', null),
      [OPTIONS.CURRENCY_CODE]: get(window, 'merchantos.locale.currency_code', null),
      [OPTIONS.DATE_TIME_FORMAT]: get(window, 'merchantos.locale.date_time_format', null),
      [OPTIONS.REGISTER_ID]: get(window, 'merchantos.session.sessData.Register.registerID', null),
      [OPTIONS.REGISTER_NAME]: get(window, 'merchantos.session.sessData.Register.name', null),
      [OPTIONS.SHOP_ID]: get(window, 'merchantos.session.sessData.Shop.shopID', null),
      [OPTIONS.SHOP_NAME]: get(window, 'merchantos.session.sessData.Shop.name', null),
      [OPTIONS.USER_ID]: get(window, 'merchantos.session.sessData.systemUserID', null),
    }
  );

export const setOptions = (options: TSFixMe) => {
  window.localStorage.setItem(HUB_OPTIONS, JSON.stringify(options));
};

export const setOption = (option: TSFixMe) => {
  window.localStorage.setItem(HUB_OPTIONS, JSON.stringify({ ...getOptions(), ...option }));
};
